import { mapState, mapGetters, mapMutations } from 'vuex'
import MultipleFileInput from '@/components/Ui/MultipleFileInput'
import Constants from '@/utils/Constants'
import Validator from '@/utils/Validator'
import MultiWebsiteItem from '../MultiWebsiteItem'

export default {
  name: 'TypeTextImage',
  components: {
    MultipleFileInput,
    MultiWebsiteItem,
  },
  data () {
    return {
      input: {
        title: null,
        body: null,
        attachments: [],
        // linkUrl: null,
        webSites: [],
      },

      // 文字数制限
      limit: {
        title: 40, // 50,
        body: 2000,
      },

      // WEBサイトの登録最大数
      websitesMax: 10,
    }
  },
  mounted () {
    if (this.deliveryType === 'signage') {
      this.limit.body = 45;
    }

    this.init()
    this.setValidate(this.formIsValid)
  },
  computed: {
    ...mapState({
      values: state => state.noticeForm.values
    }),
    ...mapGetters({
      permittedView: 'permission/permittedView',
      deliveryType: 'noticeForm/deliveryType',
    }),

    showUrl() {
      return this.deliveryType !== 'signage';
    },

    // placeholder
    placeholderTitle() {
      return '最大全角' + this.limit.title + '文字';
    },
    placeholderBody() {
      return '最大全角' + this.limit.body + '文字';
    },

    // WEBサイトの項目追加可能な場合、trueを返す
    showWebsitesAddButton() {
      return this.input.webSites.length < this.websitesMax;
    },
    websitesCount() {
      return this.input.webSites.length
    },

    // list
    fileList () {
      let list = []
      let maxLength = this.deliveryType === 'signage'
        ? 1
        : Constants.Notice.MaxImageFile
      let l = Math.min(this.input.attachments.length + 1,
        maxLength)
      for (let i = 0; i < l; i++) {
        let n = i + 1
        list.push({
          name: 'inpImageFile' + n,
          file: this.input.attachments[i]
        })
      }
      return list
    },

    // validate
    formIsValid () {
      return Validator.validText(this.input.title) &&
        Validator.validText(this.input.body) &&
        this.input.attachments.length &&
        Validator.validFile(this.input.attachments[0])
    },

    // post用にjsonbを取得
    jsonb () {
      let jsonb = {
        title: this.input.title,
        body: this.input.body
      }
      if (this.input.attachments.length) {
        jsonb.attachments = this.input.attachments
      }
      // if (Validator.validText(this.input.linkUrl)) {
      //   jsonb.linkUrl = this.input.linkUrl
      // }

      const websites = this.input.webSites.filter(item => item.name && item.url);
      if (websites.length) {
        jsonb.webSites = websites
      }

      return jsonb
    }
  },
  watch: {
    'input.title': function (to) {
      if (to) {
        this.input.title = Validator.charByteLimit(to, this.limit.title * 2)
      }
    },
    'input.body': function (to) {
      if (to) {
        this.input.body = Validator.charByteLimit(to, this.limit.body * 2)
      }
    },
    // 入力値が変更されたらモジュール全体のバリデート結果をstoreに保持
    input: {
      handler: function (to) {
        this.setValidate(this.formIsValid)
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations({
      setValidate: 'noticeForm/setValidate'
    }),

    init () {
      Object.keys(this.input)
        .forEach(key => {
          if (this.values.inpDeliveryContents &&
            this.values.inpDeliveryContents[key]) {
            this.input[key] = this.values.inpDeliveryContents[key]
          }
        })

      if (this.websitesCount < this.websitesMax) {
        this.input.webSites.push({
          name: null,
          url: null,
        });
      }
    },

    // WEBサイトの項目追加
    addWebsitesItem() {
      if (!this.showWebsitesAddButton) return;

      this.input.webSites.push({
        name: null,
        url: null,
      });
    },
    // WEBサイトの項目削除
    deleteWebsitesItem(index) {
      this.input.webSites.splice(index, 1);
    },

    // ファイル登録
    showDeleteFileButton (index) {
      if (index < this.input.attachments.length - 1) {
        return true
      } else {
        return typeof this.input.attachments[index] === 'object'
      }
    },
    changeFile ({index, file}) {
      if (this.input.attachments.length === index) {
        this.input.attachments.push(file)
      } else {
        this.$set(this.input.attachments, index, file)
      }
      // console.log('changeImageFile | input.attachments', this.input.attachments)
    },
    deleteFile ({index}) {
      this.input.attachments.splice(index, 1)
      // console.log('deleteImageFile | index : ' + index, this.input.attachments)
    },

    // ファイル登録
  }
}
